"use strict";

// Сериализация и десериализация UTM-меток.

import dom from "./dom";

function parse() {
    var utm = {
        utm_source: dom.locationParams.get("utm_source"),
        utm_medium: dom.locationParams.get("utm_medium"),
        utm_campaign: dom.locationParams.get("utm_campaign"),
    };
    return utm;
}

function isEmpty(utm) {
    return !(utm.utm_source || utm.utm_medium || utm.utm_campaign);
}

function asString(utm) {
    var utmParts = [utm.utm_source, utm.utm_medium, utm.utm_campaign];
    var utmStr = utmParts.filter(Boolean).join("/");
    return utmStr;
}

export default {
    parse: parse,
    isEmpty: isEmpty,
    asString: asString,
};
